/**
 * Socket del cliente (tienda pública) — wrapper del RealtimeCore.
 * El ciclo de vida realtime vive SOLO en RealtimeCore (una sola implementación).
 */
import RealtimeCore from './realtimeCore';

const core = new RealtimeCore('/client');

const socketClient = {
  connect: () => core.connect(),
  on: (event, cb) => core.on(event, cb),
  off: (event, cb) => core.off(event, cb),
  joinCart: (cartId) => core.joinRoom(cartId),
  leaveCart: (cartId) => core.leaveRoom(cartId),
  requestSync: (cartIds) => core.emit('reconnect:request-sync', { cartIds }),
  onResync: (handler) => core.onResync(handler),
  disconnect: () => core.disconnect(),
  get connected() { return core.connected; }
};

export default socketClient;
